import calculationError from './calculationError';

export default {
  widgets: {
    [calculationError.id]: calculationError
  }
};
